import axiosInstanceToken from '@/lib/axiosInstanceToken';

import { AxiosPromise } from 'axios';
import {
  GetServerlessProjectByIdRequest,
  GetServerlessProjectByIdResponse,
  GetServerlessProjectsResponse,
  GetServerlessTaskByIdResponse,
  GetServerlessTaskByIdRequest,
  ListServerlessTasksRequest,
  ListServerlessTasksResponse,
  TypeServerless,
  GetServerlessTaskLogsRequest,
  GetServerlessTaskLogsResponse,
  GetServerlessEndpointByIdRequest,
  GetServerlessEndpointByIdResponse,
  ServerlessRegenerateApiKeyRequest,
  ServerlessRegenerateApiKeyResponse,
  ServerlessStartEndpointRequest,
  ServerlessStartEndpointResponse,
  ServerlessStopEndpointRequest,
  ServerlessStopEndpointResponse,
  ServerlessGetTokenRequest,
  ServerlessGetTokenResponse,
  StatusServerlessProject,
  StatusServerlessTask,
  GetServerlessStorageRequest,
  GetServerlessStorageResponse,
  DeleteServerlessProjectResponse,
  DeleteServerlessProjectRequest,
  ServerlessTaskSpotByIdRequest,
  ServerlessTaskSpotByIdResponse,
  ServerlessTaskSpotStopResponse,
  ServerlessTaskSpotStopRequest,
  ServerlessTaskSpotUpdateRequest,
  ServerlessTaskSpotUpdateResponse,
  RemoveFileOnRemoteParams,
  DownloadFileOnRemoteParams,
  DownloadFileOnRemoteResponse,
  UploadFileOnRemoteParams,
  UploadFileOnRemoteResponse,
  GetServerlessStorageSizeResponse,
  GetServerlessStorageSizeRequest,
  GetServerlessMetricsEndpointRequest,
  GetServerlessMetricsEndpointResponse,
  GetServerlessMetricsDailyTasksResponse,
  GetServerlessMetricsDailyTasksRequest,
  GetServerlessMetricsDailyCostResponse,
  GetServerlessMetricsDailyCostRequest,
  GetServerlessMetricsTotalConsumptionRequest,
  GetServerlessMetricsTotalConsumptionResponse,
  GetServerlessInstancePricingResponse,
  ServerlessStorageCopyResponse,
  ServerlessStorageCopyParams,
  RunTaskResponse,
  RunTaskPayload,
  StartProjectRequest,
  RunSpotTaskResponse,
  RunSpotTaskPayload,
  CreateDeployEndpointResponse,
  CreateDeployEndpointParams,
  CreateProjectResponse,
  CreateProjectRequest,
  GetServerlessInstanceDefaultResponse,
  RunParabricksPayload,
} from './type';
import axiosInstance from '@/lib/axiosInstance';

export const getServerlessProjects = async () => {
  const { data } = await axiosInstanceToken.get<
    GetServerlessProjectsResponse,
    AxiosPromise<GetServerlessProjectsResponse>
  >('/project');
  return data;
  //mock data axios promise and set timeout 1s
  return new Promise<GetServerlessProjectsResponse>((resolve) => {
    setTimeout(() => {
      resolve({
        projects: [
          {
            created_at: '2024-03-01T00:00:00.000Z',
            updated_at: '2024-04-01T00:00:00.000Z',
            instance_type: 'A100',
            status: StatusServerlessProject.Active,
            project_id: '302bbe14-fc14-4dab-b6e7-7bd7bfadf1e1',
          },
          {
            created_at: '2024-02-01T00:00:00.000Z',
            updated_at: '2024-01-01T00:00:00.000Z',
            instance_type: 'A100',
            status: StatusServerlessProject.Deleted,
            project_id: '800d89e9-0200-4907-a4b3-cce46c9a44ec',
          },
        ],
      });
    }, 1000);
  });
};

export const getServerlessProjectById = async (
  params: GetServerlessProjectByIdRequest
) => {
  const { data } = await axiosInstanceToken.get<
    GetServerlessProjectByIdResponse,
    AxiosPromise<GetServerlessProjectByIdResponse>
  >(`/project/${params.project_id}`);
  return data;
  // const data = await getServerlessProjects();
  // return data.projects.find(
  //   (project) => project.project_id === params.project_id
  // )!;
};

export const deleteServerlessProject = async (
  params: DeleteServerlessProjectRequest
) => {
  const { data } = await axiosInstanceToken.delete<
    DeleteServerlessProjectResponse,
    AxiosPromise<DeleteServerlessProjectResponse>
  >(`/project`, {
    data: {
      project_id: params.project_id,
    },
  });
  return data;
};

export const listServerlessTasks = async (
  params: ListServerlessTasksRequest
) => {
  const { data } = await axiosInstanceToken.get<
    ListServerlessTasksResponse,
    AxiosPromise<ListServerlessTasksResponse>
  >(`/task/list`, {
    params: {
      ...(params.project_id !== undefined && { project_id: params.project_id }),
    },
  });
  return data;
  return new Promise<ListServerlessTasksResponse>((resolve) => {
    setTimeout(() => {
      resolve({
        tasks: [
          {
            id: '5971cc7c-2c3a-4130-8929-c39a0bc4b429',
            name: 'Task 1',
            status: StatusServerlessTask.ComplateSuccess,
            created_at: '2042-01-01T00:00:00.000Z',
            trigger_type: TypeServerless.Server,
            project_id: '302bbe14-fc14-4dab-b6e7-7bd7bfadf1e1',
          },
          {
            id: '087ef5a7-5a6f-45bc-bfdd-e64bf66bdd00',
            name: undefined,
            status: StatusServerlessTask.ComplateFailed,
            created_at: '2042-01-01T00:00:00.000Z',
            trigger_type: TypeServerless.Server,
            project_id: '302bbe14-fc14-4dab-b6e7-7bd7bfadf1e1',
          },
          {
            id: '129549c9-6368-43c4-8b69-059fe23da82e',
            name: 'test ja',
            status: StatusServerlessTask.ComplateSuccess,
            created_at: '2042-01-01T00:00:00.000Z',
            trigger_type: TypeServerless.Server,
            project_id: '302bbe14-fc14-4dab-b6e7-7bd7bfadf1e1',
          },
        ],
      });
    }, 1000);
  });
};

export const getServerlessTaskById = async (
  params: GetServerlessTaskByIdRequest
) => {
  const { data } = await axiosInstanceToken.get<
    GetServerlessTaskByIdResponse,
    AxiosPromise<GetServerlessTaskByIdResponse>
  >(`/task/${params.task_id}`);
  return data;
  return new Promise<GetServerlessTaskByIdResponse>((resolve) => {
    setTimeout(() => {
      resolve({
        id: params.task_id,
        name: 'Task 1',
        status: StatusServerlessTask.ComplateSuccess,
        created_at: '2042-01-01T00:00:00.000Z',
        trigger_type: TypeServerless.Server,
        project_id: '302bbe14-fc14-4dab-b6e7-7bd7bfadf1e1',
        completed_at: '2042-02-01T00:00:00.000Z',
        duration: 2340,
      });
    }, 1000);
  });
};

export const getServerlessTaskLogs = async (
  params: GetServerlessTaskLogsRequest
) => {
  const { data } = await axiosInstanceToken.get<
    GetServerlessTaskLogsResponse,
    AxiosPromise<GetServerlessTaskLogsResponse>
  >(`/task/${params.task_id}/log`);
  return data;
  return new Promise<GetServerlessTaskLogsResponse>((resolve) => {
    setTimeout(() => {
      resolve({
        task_id: params.task_id,
        log: `[2023-09-30 10:00:15] Task started
[2023-09-30 10:00:16] Initializing...
[2023-09-30 10:00:20] Processing data
[2023-09-30 10:01:30] Data processing complete
[2023-09-30 10:01:31] Generating report
[2023-09-30 10:01:45] Task completed successfully
      `,
      });
    }, 1000);
  });
};

export const getServerlessEndpointById = async (
  params: GetServerlessEndpointByIdRequest
) => {
  const { data } = await axiosInstanceToken.get<
    GetServerlessEndpointByIdResponse,
    AxiosPromise<GetServerlessEndpointByIdResponse>
  >(`/endpoint/${params.project_id}`);
  return data;
  return new Promise<GetServerlessEndpointByIdResponse>((resolve) => {
    setTimeout(() => {
      resolve({
        endpoint: 'endpoint-123',
        api_key: 'api-key-123',
        deployed_at: '2042-01-01T00:00:00.000Z',
        project_id: params.project_id,
        is_active: true,
      });
    }, 1000);
  });
};

export const regenerateApiKey = async (
  params: ServerlessRegenerateApiKeyRequest
) => {
  const { data } = await axiosInstanceToken.post<
    ServerlessRegenerateApiKeyResponse,
    AxiosPromise<ServerlessRegenerateApiKeyResponse>
  >(`/endpoint/regenerate_api_key`, {
    project_id: params.project_id,
  });
  return data;
};

export const startEndpoint = async (params: ServerlessStartEndpointRequest) => {
  const { data } = await axiosInstanceToken.post<
    ServerlessStartEndpointResponse,
    AxiosPromise<ServerlessStartEndpointResponse>
  >(`/endpoint/start`, {
    project_id: params.project_id,
  });
  return data;
};

export const stopEndpoint = async (params: ServerlessStopEndpointRequest) => {
  const { data } = await axiosInstanceToken.post<
    ServerlessStopEndpointResponse,
    AxiosPromise<ServerlessStopEndpointResponse>
  >(`/endpoint/stop`, {
    project_id: params.project_id,
  });
  return data;
};

export const getServerlessToken = async (params: ServerlessGetTokenRequest) => {
  const { data } = await axiosInstance.get<
    ServerlessGetTokenResponse,
    AxiosPromise<ServerlessGetTokenResponse>
  >(`/auth/token-cli`);
  return data;
  //mock data axios promise and set timeout 1s
  // return new Promise<ServerlessGetTokenResponse>((resolve) => {
  //   setTimeout(() => {
  //     resolve({
  //       token: 'float16-rw-ed6bfa61-cc976fe6-labnaja',
  //     });
  //   }, 1000);
  // });
};

export const getServerlessStorage = async (
  params: GetServerlessStorageRequest
) => {
  const { data } = await axiosInstanceToken.get<
    GetServerlessStorageResponse,
    AxiosPromise<GetServerlessStorageResponse>
  >(`/storage/list`, {
    params: {
      project_id: params.project_id,
    },
  });
  return data;
};

export const getServerlessStorageSize = async (params: GetServerlessStorageSizeRequest) => {
  const { data } = await axiosInstanceToken.get<GetServerlessStorageSizeResponse>(`/storage/size/${params.project_id}`);
  return data;
};

export const downloadFileOnRemote = async ( 
  params: DownloadFileOnRemoteParams
) => {
  const { data } = await axiosInstanceToken.post<DownloadFileOnRemoteResponse>(`/storage/download`,params);
  return data;
};

export const uploadFileOnRemote = async (
  params: UploadFileOnRemoteParams
) => {
  const { data } = await axiosInstanceToken.post<UploadFileOnRemoteResponse>(`/storage/upload`, params);
  return data;
};

export async function removeFileOnRemote(
  params: RemoveFileOnRemoteParams


): Promise<void> {
  const response = await axiosInstanceToken.delete(`/storage/remove`, {
    data: params,
  });

  return response.data;
}

export const getServerlessTaskSpotById = async (
  params: ServerlessTaskSpotByIdRequest
) => {
  const { data } = await axiosInstanceToken.get<
    ServerlessTaskSpotByIdResponse,
    AxiosPromise<ServerlessTaskSpotByIdResponse>
  >(`/task/spot/${params.task_id}`);

  return data;
};

export const stopServerlessTaskSpot = async (
  params: ServerlessTaskSpotStopRequest
) => {
  const { data } = await axiosInstanceToken.post<
    ServerlessTaskSpotStopResponse,
    AxiosPromise<ServerlessTaskSpotStopResponse>
  >(`/task/spot/stop`, {
    task_id: params.task_id,
    should_stop: true,
  });
  return data;
};

export const updateServerlessTaskSpot = async (
  params: ServerlessTaskSpotUpdateRequest
) => {
  const { data } = await axiosInstanceToken.post<
    ServerlessTaskSpotUpdateResponse,
    AxiosPromise<ServerlessTaskSpotUpdateResponse>
  >(`/task/spot/spending/update`, params);
  return data;
};


export const getServerlessMetricsEndpoint = async (
  params: GetServerlessMetricsEndpointRequest
) => {
  const { data } = await axiosInstanceToken.get<GetServerlessMetricsEndpointResponse>(`/metrics/endpoint/${params.project_id}`, {
    params:{
      start_date: params.start_date,
      end_date: params.end_date,
    }
  });
  return data;
};

export const getServerlessMetricsTotalConsumption = async (
  params: GetServerlessMetricsTotalConsumptionRequest
) => {
  const { data } = await axiosInstanceToken.get<GetServerlessMetricsTotalConsumptionResponse>(`/metrics/total_consumption/${params.project_id}`,{
    params:{
      start_date: params.start_date,
      end_date: params.end_date,
    }
  });
  return data;
};

export const getServerlessMetricsDailyTasks = async (
  params: GetServerlessMetricsDailyTasksRequest
) => {
  const { data } = await axiosInstanceToken.get<GetServerlessMetricsDailyTasksResponse>(`/metrics/daily_tasks/${params.project_id}`,{
    params:{
      start_date: params.start_date,
      end_date: params.end_date,
    }
  });
  return data;
};

export const getServerlessMetricsDailyCost = async (
  params: GetServerlessMetricsDailyCostRequest
) => {
  const { data } = await axiosInstanceToken.get<GetServerlessMetricsDailyCostResponse>(`/metrics/daily_cost/${params.project_id}`,{
    params:{
      start_date: params.start_date,
      end_date: params.end_date,
    }
  });
  return data;
};


export const getServerlessInstancePricing = async () => {
  // return new Promise<GetServerlessInstancePricingResponse>((resolve) => {
  //   setTimeout(() => {
  //     resolve([
  //       {
  //         instance_id: 'instance-123',
  //         instance_type: 'l4',
  //         price_per_hours: 20,
  //         spot_price_per_hours: 4,
  //         instance_provider: 'aws',
  //         instance_region: 'us-east-1',
  //         storage_price_per_month: 10,
  //       },
  //       {
  //         instance_id: 'instance-1234',
  //         instance_type: 'l5',
  //         price_per_hours: 20,
  //         spot_price_per_hours: 4,
  //         instance_provider: 'Siam AI Cloud',
  //         instance_region: 'bkk-1',
  //         storage_price_per_month: 10,
  //       },
  //       {
  //         instance_id: 'instance-12345',
  //         instance_type: 'l7',
  //         price_per_hours: 20,
  //         spot_price_per_hours: 4,
  //         instance_provider: 'nt',
  //         instance_region: 'bkk-1',
  //         storage_price_per_month: 10,
  //       },
  //     ]);
  //   }, 1000);
  // });
  const { data } = await axiosInstanceToken.get<
    GetServerlessInstancePricingResponse,
    AxiosPromise<GetServerlessInstancePricingResponse>
  >(`/instance`);
  return data?.data;
};

export const getServerlessStorageCopy = async (
  params: ServerlessStorageCopyParams
) => {
  const { data } = await axiosInstanceToken.post<ServerlessStorageCopyResponse>(`/storage/copy-between-project`, params);
  return data;
};


export const runTask = async (
  payload: RunTaskPayload
): Promise<RunTaskResponse> => {
  const response = await axiosInstanceToken.post<RunTaskResponse>(
    `/task/run`,
    payload
  );
  return response.data;
};

export const runTaskSSE = async (
  payload: RunTaskPayload,
  token: string
): Promise<Response> => {
  const baseUrl = axiosInstanceToken.defaults.baseURL || '';
  const response = await fetch(`${baseUrl}/task/run`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response;
};

export const cancelTask = async (
  taskId: string,
  token: string,
  reason: string = 'user_requested'
): Promise<{ status: string; task_id: string; details: string }> => {
  const baseUrl = axiosInstanceToken.defaults.baseURL || '';
  const response = await fetch(`${baseUrl}/task/cancel/${taskId}?reason=${encodeURIComponent(reason)}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response.json();
};

export const runSpotTask = async (
  payload: RunSpotTaskPayload
): Promise<RunSpotTaskResponse> => {
  const response = await axiosInstanceToken.post<RunSpotTaskResponse>(
    `/task/spot/run`,
    payload
  );
  return response.data;
};

export async function startProject({
  config,
  project_id,
  requirements_content,
}: StartProjectRequest): Promise<any> {
  const response = await axiosInstanceToken.post(`/project/start`, {
    project_id,
    config: { ...config, mode: "realtime" },
    requirements_content,
  } as StartProjectRequest);
  return response.data;
}

export async function createDeploy(
  data: CreateDeployEndpointParams
): Promise<CreateDeployEndpointResponse> {
  const response = await axiosInstanceToken.post(`/endpoint`, {
    ...data,
    config: {
      ...data.config,
      mode: "realtime",
    },
  });

  return response.data;
}

export async function createProject(data: CreateProjectRequest): Promise<CreateProjectResponse> {
  const response = await axiosInstanceToken.post(`/project`, data);
  return response.data;
}
export const getServerlessInstanceDefault = async () => {
  const { data } = await axiosInstanceToken.get<
    GetServerlessInstanceDefaultResponse,
    AxiosPromise<GetServerlessInstanceDefaultResponse>
  >(`/default_instance`);
  return data?.data;
};
export const updateServerlessProjectName = async (data: {
  project_id: string;
  project_name: string;
}): Promise<any> => {
  const response = await axiosInstanceToken.post(
    `/project/${data.project_id}/to/${data.project_name}`
  );
  return response.data;
};

export const runParabricksSSE = async (
  payload: RunParabricksPayload,
  token: string
): Promise<Response> => {
  const baseUrl = axiosInstanceToken.defaults.baseURL || '';
  const response = await fetch(`${baseUrl}/task/run/parabricks`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'text/event-stream',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP ${response.status}: ${errorText}`);
  }

  return response;
};

